import { useRef } from "react";
import { useUpdateDocumentUrlMutation } from "../../../../../../../features/authentication/teacherDocumentApiSlice";
import PropTypes from "prop-types";
import { Form, Button } from "react-bootstrap";
import Modal from "../../../../../../../components/Modal";
import CustomToast from "../../../../../../../components/Toast";

const UpdateDescriptionModal = ({ showModal, setShowModal, document, onUpdateDescription }) => {
  const [updateDocumentUrl, {isLoading: urlIsLoading}] = useUpdateDocumentUrlMutation();
  const urlRef = useRef();

  const handleUpdateDocumentUrl = async (e) => {
    e.preventDefault();
    if (urlRef.current.value == document.url) {
      setShowModal(false);
      return;
    }

    const option = {
      documentId: document?.documentId,
      url: urlRef.current.value
    };

    try {
      const result = await updateDocumentUrl(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Url, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Url Changes Saved Successfully.', 'success');
        setShowModal(false);
        onUpdateDescription();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length == 0) {
      event.target.setCustomValidity('');
    } else {
      try {
        new URL(inputValue);
        event.target.setCustomValidity('');
      } catch {
        event.target.setCustomValidity('Please enter a valid URL');
      }

      if (inputValue.length > 255) event.target.setCustomValidity('URL length must be less than 256 characters');
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
      titleName='Update URL'
      contentWidth='50%'>
      <Form className='d-flex flex-column' onSubmit={(e) => handleUpdateDocumentUrl(e)}>

        <Form.Group id="url" className='w-100'>
          <Form.Label>{'URL (must start with http:// or https://)'}</Form.Label>
          <Form.Control disabled={urlIsLoading} type="url" className='w-100' required defaultValue={document?.url} ref={urlRef}
            onInput={handleValidation} />
        </Form.Group>

        <div className='d-flex flex-row justify-content-end gap-2 mt-3'>
          <Button style={{ minWidth: '90px' }} variant='castleGray' onClick={() => setShowModal(false)}>Cancel</Button>
          <Button disabled={urlIsLoading} style={{ minWidth: '90px' }} variant='castleRed' type='submit'>{urlIsLoading ? 'Saving...' : 'Save'}</Button>
          </div>
      </Form>
    </Modal>
  );
};

UpdateDescriptionModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  document: PropTypes.object,
  setId: PropTypes.number,
  onUpdateDescription: PropTypes.func
};

export default UpdateDescriptionModal;